import {
  Grid,
  TextField,
  FormHelperText,
  InputLabel,
  Box,
  Typography,
} from "@mui/material";

const Input = (props) => {
  const { label, name, formik, required, onChange, title, ...rest } = props;
  return (
    <Grid>
      <Grid>
        <Box
          sx={{
            borderLeft: formik.errors[name] ? "4px solid #ca2e2e" : "",
            paddingLeft: formik.errors[name] ? "16px" : "",
          }}
        >
          <InputLabel
            htmlFor={name}
            sx={{
              marginBottom: "15px",
              textAlign: "left",
              textStyle: "none",
            }}
          >
            {title}
            <Typography
              variant={props.labelSize ? "h3" : "body1"}
              sx={{
                fontWeight: required ? "bold" : "500",
              }}
            >
              {label}
            </Typography>
          </InputLabel>
          <TextField
            sx={{ width: label === "id" ? 100 : "100%" }}
            error={!!formik.errors[name]}
            id={name}
            onChange={onChange}
            {...formik.getFieldProps(`${name}`)}
            {...rest}
          />
          {!!formik.errors[name] && (
            <FormHelperText
              error
              sx={{
                marginTop: "16px",
                fontWeight: "bolder",
                fontSize: "1rem",
                letterSpacing: "0.00938em",
                lineHeight: "1.43",
              }}
            >
              {formik.errors[name]}
            </FormHelperText>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default Input;
